import type { SVGProps } from "react";
import * as React from "react";

const SvgIconZoho = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <path
      fill="#D02132"
      d="M65.732 74.991H9.679c-5.21 0-9.473-4.263-9.473-9.474V9.465c0-5.21 4.263-9.474 9.473-9.474h56.053c5.21 0 9.474 4.263 9.474 9.474v56.052a9.45 9.45 0 0 1-9.474 9.474"
    />
    <path
      fill="#fff"
      d="M29.416 55.018H55.47c.316 0 .395.078.395.394v6.158c0 .316-.08.395-.395.395H18.52q-.79 0-.79-.71v-2.843c0-.158 0-.316.08-.394 1.895-2.685 3.79-5.369 5.605-7.974C26.97 44.99 30.6 39.86 34.153 34.807c3.079-4.342 6.158-8.763 9.237-13.105.316-.395.631-.869.947-1.263a.84.84 0 0 0 .237-.395H20.1c-.237 0-.316-.08-.316-.316v-6.395c0-.315.158-.315.395-.315h35.685c.236 0 .315.079.315.315v3.08c0 .236-.079.394-.237.63-2.29 3.317-4.578 6.633-6.947 9.948l-7.579 10.895c-2.842 4.105-5.684 8.21-8.605 12.237a605 605 0 0 1-3.395 4.816c.079-.158.079-.08 0 .079"
    />
  </svg>
);
export default SvgIconZoho;
